var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('document-toolbar-action',{attrs:{"id":"managementPartButton","icon":"edit","text":"document.managementOption","action":_vm.goToDocumentManagement,"enable":_vm.enable,"isButton":_vm.isButton}})}
var staticRenderFns = []

export { render, staticRenderFns }